var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-base"},[_c('nav-menu'),_c('div',{staticClass:"user-right"},[_c('nav-header'),_c('keep-alive',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }